import React, { Component } from "react";
import { get as _get, isEqual as _isEqual } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";

import { CustomModal, showAlertMessage } from "../common/formElements";

import { fetchCampaignCustomFields } from "../../redux/services/campaignSetup";

import { updateLoadingState } from "../../redux/actions/application";

import UploadCustomFields from "../../pages/CampaignSetup/components/CustomFields/UploadCustomFields";

class AddEditCustomFields extends Component {

  constructor(props) {
    super(props);

    this.defaultState = {
      callCustomFieldSubmitAPI: false,
      existingCustomFields: []
    };

    this.state = {
      ...this.defaultState,
      showModal: false
    };
  }

  componentDidUpdate(prevProps, prevState) {

    if (!_isEqual(prevState.showModal, this.state.showModal) && _get(this.state, "showModal", false) === true) {

      this._fetchCampaignCustomFields();
    }
  }

  _fetchCampaignCustomFields = async () => {
    const { campaignId, updateLoadingState } = this.props;

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const reqRes = await fetchCampaignCustomFields(campaignId);

      if ((reqRes.flag || false) === true) {
        let allCustomFields = [];
        _get(reqRes, "data", []).forEach((field) => {
          allCustomFields.push({
            field_name: _get(field, "custom_field_name", ""),
            field_type: _get(field, "field_type", ""),
            is_required: _get(field, "is_required", false),
          });
        });
        this.setState({ existingCustomFields: allCustomFields });
        if (typeof updateLoadingState === "function") { updateLoadingState(false); }
      } else {
        showAlertMessage(_get(reqRes, "message", "Something went wrong while fetching custom fields."));
      }
    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching fetching custom fields."));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  _showModal = () => {
    const { campaignId, intl } = this.props;

    if ((campaignId || null) === null) {
      showAlertMessage(intl.formatMessage({ id: "error.select_atleast_one", defaultMessage: "Please select at least one {field}." },
        { field: intl.formatMessage({ id: "campaign", defaultMessage: "campaign" }) }
      ));
      return false;
    }

    this.setState({ ...this.defaultState, showModal: true });
  }

  _closeModal = () => {
    const { setState } = this.props;

    this.setState({ ...this.defaultState, showModal: false });

    //Set Parent Component States
    if (typeof setState === "function") { setState({ reloadBriefList: true }); }
  }

  /*async _submitCustomFields() {
    const { source = "", campaignId, updateLoadingState, intl } = this.props;
    const { uploadedCustomFields } = this.state;
    const finalUploadedCustomFields = (uploadedCustomFields || []).filter(item => item.field_name.trim() !== "");

    if (_isEmpty(finalUploadedCustomFields)) {
      showAlertMessage(intl.formatMessage({ id: "error.select_atleast_one", defaultMessage: "Please select at least one {field}." },
        { field: intl.formatMessage({ id: "campaign_setup.custom_fields.title", defaultMessage: "Custom Fields" }) }
      ));
      return false;
    }

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      if (typeof saveCustomFields === "function") {

        const payload = {
          campaignId,
          data: {
            json: finalUploadedCustomFields,
          },
        };

        const response = await saveCustomFields(payload);
        if ((response.flag || false) === true) {

          showAlertMessage(_get(response, "data.message", "Custom fields saved successfully."), "success");
          if (source === "campaign_setup") {
            goTONext();
          } else if (source === "") {
            this._closeModal();
          }
        } else {
          showAlertMessage(_get(response, "message", "Something went wrong while saving custom fields."));
        }
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while saving custom fields."));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }*/

  _renderModalContent = () => {
    const { campaignId, clientId, intl } = this.props;
    const { existingCustomFields, callCustomFieldSubmitAPI, showModal } = this.state;

    return (
      <CustomModal
        isOpen={showModal}
        size="lg"
        className="text-capitalize"
        bodyClassName="overflow-unset"
        modalTitle={(intl.formatMessage({ id: "campaign_setup.custom_fields.title", defaultMessage: "Custom Fields" }))}
        onHide={() => this._closeModal()}
        onClose={() => this._closeModal()}
      >
        <>
          <UploadCustomFields
            source="campaign_edit"
            existingCustomFields={(existingCustomFields || [])}
            selectedCampaignId={(campaignId || null)}
            clientId={(clientId || null)}
            goToNext={() => this._closeModal()}
            callCustomFieldSubmitAPI={(callCustomFieldSubmitAPI || false)}
          />

          <div className="row mt-auto">
            <div className="col-lg-12">
              <div className="d-flex align-items-center justify-content-between gap-4 mt-4">
                <button className="btn btn-primary text-capitalize" onClick={() => this.setState({ callCustomFieldSubmitAPI: true })}>
                  <FormattedMessage id="btn.submit" defaultMessage="submit" />
                </button>
              </div>
            </div>
          </div>
        </>
      </CustomModal>
    );
  }

  render() {

    return (
      <>

        {this._renderModalContent()}

        <Dropdown.Item className="dropdown-item d-block waves-effect text-capitalize" onClick={() => this._showModal()} >
          <FormattedMessage id="campaign_setup.custom_fields.title" defaultMessage="Custom Fields" />
        </Dropdown.Item>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data)),
});

export default connect(null, mapDispatchToProps)(injectIntl(AddEditCustomFields));
